import { render, staticRenderFns } from "./PropertyPaymentInputs.vue?vue&type=template&id=22a51b42&"
import script from "./PropertyPaymentInputs.vue?vue&type=script&lang=js&"
export * from "./PropertyPaymentInputs.vue?vue&type=script&lang=js&"
import style0 from "./PropertyPaymentInputs.vue?vue&type=style&index=0&id=22a51b42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports